import React, { useState, useEffect } from "react";
import { InfoWindow } from "@react-google-maps/api";
import Post from "../feed/Post";

const MapInfoWindow = ({ latitude, longitude, postId, setSelected }) => {
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [user, setUser] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const url = `${process.env.REACT_APP_HOST}/api/v1/posts/${postId}`;
    fetch(url)
      .then((response) => {
        if (response.ok) {
          response.json().then((response) => {
            const post = response.data.attributes;
            setDescription(post.description);
            setImage(post.image);
            setUser(post.user);
            setLoaded(true);
          });
        } else {
          response.json().then((data) => {
            console.error("Error:", data);
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [postId]);

  return (
    <>
      {loaded ? (
        <InfoWindow
          position={{
            lat: parseFloat(latitude),
            lng: parseFloat(longitude),
          }}
          onCloseClick={() => {
            setSelected(null);
            setLoaded(false);
          }}
        >
          <Post
            description={description}
            image={image}
            key={postId}
            user={user}
          />
        </InfoWindow>
      ) : null}
    </>
  );
};

export default MapInfoWindow;
